export const normalizeMedicalQuoteType = (quoteType) => {
  if (quoteType === 'standard') {
    return 'Virgin';
  }

  if (quoteType === 'advanced') {
    return 'Renewal';
  }
};
